import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import SearchInput from "../../components/SearchInput";
import { authFetch } from "../../utils/api";
import "../../styles/admin/aseguradoras.css";

export default function Aduanas() {
  const [q, setQ] = useState("");
  const [aduanas, setAduanas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);

    authFetch('/api/Aduanas')
      .then((res) => {
        if (!res.ok) {
          throw new Error("No cargan las aduanas, intentar mas tarde");
        }
        return res.json();
      })
      .then((data) => {
        setAduanas(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setAduanas([]);
        setLoading(false);
      });
  }, []);

  const rows = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return aduanas;
    return aduanas.filter(r =>
      [r.nombre, r.contacto, r.telefono, r.correo].some(v => String(v).toLowerCase().includes(t))
    );
  }, [q, aduanas]);

  const handleAgregar = () => {
    navigate('/admin/aduanas/agregar');
  };

  const handleEditar = (aduana) => {
    navigate(`/admin/aduanas/editar/${aduana.id}`);
  };

  const handleDelete = async (aduana) => {
    const confirmacion = window.confirm(
      `¿Estás seguro de que deseas eliminar la aduana "${aduana.nombre}"?`
    );

    if (!confirmacion) {
      return;
    }

    try {
      const response = await authFetch(`/api/Aduanas/${aduana.id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('No se pudo eliminar la aduana.');
      }

      setAduanas(prevAduanas =>
        prevAduanas.filter(a => a.id !== aduana.id)
      );

      alert('Aduana eliminada exitosamente.');

    } catch (err) {
      alert(`Error al eliminar: ${err.message}`);
    }
  };

  return (
    <main className="aseg-main">
      <header className="aseg-header">
        <h1 className="aseg-title">Aduanas</h1>
        <button
          type="button"
          className="aseg-btn"
          onClick={handleAgregar}
        >
          Agregar Aduana
        </button>
      </header>

      <SearchInput
        placeholder="Buscar aduanas"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />

      {loading && <p>Cargando aduanas...</p>}

      {error && <p style={{ color: '#e11d48' }}>Error: {error}</p>}

      {!loading && !error && (
        <section className="aseg-card">
          <div className="aseg-table-wrapper">
            <table className="aseg-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Teléfono</th>
                  <th>Correo electrónico</th>
                  <th className="col-acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map(r => (
                    <tr key={r.id}>
                      <td>{r.nombre}</td>
                      <td>{r.telefono}</td>
                      <td className="td-email">{r.correoElectronico}</td>
                      <td className="td-acciones">
                        <button
                          type="button"
                          className="aseg-link"
                          onClick={() => handleEditar(r)}
                        >
                          Editar
                        </button>
                        <button
                          type="button"
                          className="aseg-link"
                          style={{ marginLeft: '8px' }}
                          onClick={() => handleDelete(r)}
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="aseg-empty">
                      {q
                        ? `No se encontraron aduanas que coincidan con "${q}"`
                        : "No hay aduanas registradas."}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>
      )}
    </main>
  );
}